var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttemption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90846 1.83252C8.82646 0.20052 11.1749 0.20052 12.0917 1.83252L18.7877 13.7365C19.6877 15.3373 18.5321 17.3125 16.6973 17.3125H3.30406C1.46806 17.3125 0.312462 15.3373 1.21246 13.7365L7.90846 1.83252ZM11.2001 13.7137C11.2001 14.032 11.0736 14.3372 10.8486 14.5622C10.6235 14.7873 10.3183 14.9137 10.0001 14.9137C9.6818 14.9137 9.37658 14.7873 9.15153 14.5622C8.92649 14.3372 8.80006 14.032 8.80006 13.7137C8.80006 13.3955 8.92649 13.0902 9.15153 12.8652C9.37658 12.6402 9.6818 12.5137 10.0001 12.5137C10.3183 12.5137 10.6235 12.6402 10.8486 12.8652C11.0736 13.0902 11.2001 13.3955 11.2001 13.7137ZM10.0001 4.11372C9.6818 4.11372 9.37658 4.24015 9.15153 4.46519C8.92649 4.69024 8.80006 4.99546 8.80006 5.31372V8.91372C8.80006 9.23198 8.92649 9.5372 9.15153 9.76225C9.37658 9.98729 9.6818 10.1137 10.0001 10.1137C10.3183 10.1137 10.6235 9.98729 10.8486 9.76225C11.0736 9.5372 11.2001 9.23198 11.2001 8.91372V5.31372C11.2001 4.99546 11.0736 4.69024 10.8486 4.46519C10.6235 4.24015 10.3183 4.11372 10.0001 4.11372Z",
    fill: "#FFBC42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttemption);
export default __webpack_public_path__ + "static/media/attemption.9c844442.svg";
export { ForwardRef as ReactComponent };